import { useQuery } from '@tanstack/react-query';
import { api } from '@/api/api';
import { queryKeys } from '@/libs/queryKeys';

/** React Query for the earnings rollup of a single echo. Disabled when `echoId` is empty. */
export const useEchoEarningsQuery = (echoId: string) =>
  useQuery({
    queryKey: queryKeys.earnings.echo(echoId),
    queryFn: () => api.payouts.getEchoEarnings(echoId),
    staleTime: 60000,
    enabled: !!echoId,
  });
